'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Checkbox, Divider, Modal } from '@common/components';
import { useToast } from '@common/hooks';
import { SvgInfo, SvgShare2 } from '@common/icon';
import { cn } from '@core/utils';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { useRef, useState } from 'react';
import { AuthMutation, AuthQueryOptions, TERM_CATEGORY, VERIFICATION_TYPE } from '@/api';
import { GlobalDesktopSideAdBanner } from '@/app/_components/ads';
import { CustomLink } from '@/app/_components/CustomLink';
import { openShareDrawer } from '@/app/_components/GlobalModal/_components/ShareDrawer';
import { BottomSheet } from '@/app/welmarket/_components/BottomSheet';
import { Image } from '@/components/client';
import { IMAGE_PLACEHOLDER, ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';
import { useGlobalStore } from '@/stores/GlobalStore';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { PointUsageSection } from './PointUsageSection';
interface ProductDetail {
  thumbnailUrl?: string;
  productName?: string;
  brandName?: string;
  originalPrice?: number;
  brandNotice?: string;
  productType?: string;
}
interface ProductDetailClientProps {
  idx: string;
  product: ProductDetail;
}
export const ProductDetailClient = t0 => {
  const $ = _c(221);
  const {
    idx,
    product
  } = t0;
  const {
    thumbnailUrl,
    productName: t1,
    brandName,
    originalPrice: t2,
    brandNotice,
    productType
  } = product;
  const productName = t1 === undefined ? "" : t1;
  const originalPrice = t2 === undefined ? 0 : t2;
  const isLogin = useAuthStore(_temp);
  const myInfo = useAuthStore(_temp2);
  const setTermsDrawerType = useGlobalStore(_temp3);
  const router = useCustomRouter();
  const pathname = usePathname();
  const queryClient = useQueryClient();
  const {
    toast,
    toastError
  } = useToast();
  let t3;
  if ($[0] !== idx) {
    t3 = AuthQueryOptions["get:/wello/v2/auth/point-market/order/preview"]({
      query: {
        productIdIdx: idx
      }
    });
    $[0] = idx;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = isLogin === true;
  let t5;
  if ($[2] !== t3 || $[3] !== t4) {
    t5 = {
      ...t3,
      enabled: t4,
      select: _temp4
    };
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const previewQuery = useQuery(t5);
  const isAuthResolving = isLogin === undefined;
  const isPreviewLoading = isLogin === true && previewQuery.isLoading;
  const availablePoints = previewQuery.data?.point.availablePoint ?? 0;
  const usedPoints = previewQuery.data?.point.usedPoint ?? originalPrice;
  const leftPoints = availablePoints - usedPoints;
  const isPointsInsufficient = isLogin === true && leftPoints < 0;
  const [isCheckedExp, setIsCheckedExp] = useState(false);
  const [isCheckedPhone, setIsCheckedPhone] = useState(false);
  const [isCheckedMms, setIsCheckedMms] = useState(false);
  const [isCheckedPrivacy, setIsCheckedPrivacy] = useState(false);
  const isAllChecked = isCheckedExp && isCheckedPhone && isCheckedMms && isCheckedPrivacy;
  const [isVerifyModalOpen, setIsVerifyModalOpen] = useState(false);
  const agreementSectionRef = useRef(null);
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = AuthMutation["post:/wello/v2/auth/point-market/order/payments"]();
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== brandName || $[7] !== idx || $[8] !== originalPrice || $[9] !== productName || $[10] !== queryClient || $[11] !== router || $[12] !== toast) {
    t7 = async () => {
      trackGtmEvent(GTM_EVENT_TYPE.USE_POINT, {
        product_name: productName,
        product_brand: brandName ?? "",
        product_value: originalPrice,
        product_id: idx
      });
      await queryClient.invalidateQueries();
      toast({
        message: "\uAD6C\uB9E4\uD558\uC2E0 \uAD50\uD658\uAD8C\uC774 \uBB38\uC790\uB85C \uBC1C\uC1A1\uB418\uC5C8\uC5B4\uC694."
      });
      router.replace(ROUTES.POINT_MARKET_ORDER_COMPLETE.pathname);
    };
    $[6] = brandName;
    $[7] = idx;
    $[8] = originalPrice;
    $[9] = productName;
    $[10] = queryClient;
    $[11] = router;
    $[12] = toast;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== toastError) {
    t8 = error => {
      toastError({
        error
      });
    };
    $[14] = toastError;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = {
      ...t6,
      onSuccess: t7,
      onError: t8
    };
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const {
    mutate: pay,
    isPending: isPaying
  } = useMutation(t9);
  let t10;
  if ($[19] !== pathname) {
    t10 = ROUTES.EASY_CERTIFICATION.withSearchParams({
      searchParams: {
        verification: VERIFICATION_TYPE.PROFILE_UPDATE,
        isNotUseCertificateCache: "Y",
        redirect: pathname ?? ""
      }
    });
    $[19] = pathname;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const verificationHref = t10;
  let t11;
  if ($[21] !== idx || $[22] !== isAllChecked || $[23] !== isAuthResolving || $[24] !== isLogin || $[25] !== isPointsInsufficient || $[26] !== isPreviewLoading || $[27] !== myInfo?.cellPhone?.length || $[28] !== pathname || $[29] !== pay || $[30] !== router || $[31] !== toast) {
    t11 = () => {
      if (isAuthResolving || isPreviewLoading) {
        return;
      }
      if (!isLogin) {
        router.push(ROUTES.LOGIN.withSearchParams({
          searchParams: {
            redirect: pathname ?? ""
          }
        }));
        return;
      }
      if (isPointsInsufficient) {
        return;
      }
      if (!isAllChecked) {
        toast({
          message: "\uC57D\uAD00 \uB3D9\uC758\uAC00 \uD544\uC694\uD574\uC694."
        });
        agreementSectionRef.current?.scrollIntoView({
          block: "center"
        });
        return;
      }
      if ((myInfo?.cellPhone?.length ?? 0) < 5) {
        setIsVerifyModalOpen(true);
        return;
      }
      pay({
        body: {
          productIdIdx: idx
        }
      });
    };
    $[21] = idx;
    $[22] = isAllChecked;
    $[23] = isAuthResolving;
    $[24] = isLogin;
    $[25] = isPointsInsufficient;
    $[26] = isPreviewLoading;
    $[27] = myInfo?.cellPhone?.length;
    $[28] = pathname;
    $[29] = pay;
    $[30] = router;
    $[31] = toast;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  const handlePaymentClick = t11;
  const handleShare = _temp5;
  const ctaDisabled = isAuthResolving || isPreviewLoading || isLogin === true && (isPointsInsufficient || isPaying);
  const ctaLabel = isPointsInsufficient ? "\uD3EC\uC778\uD2B8\uAC00 \uBD80\uC871\uD574\uC694" : "\uACB0\uC81C\uD558\uAE30";
  const safeThumbnail = thumbnailUrl || IMAGE_PLACEHOLDER;
  let t12;
  if ($[33] !== myInfo) {
    t12 = myInfo?.cellPhone ? myInfo.cellPhone.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3") : null;
    $[33] = myInfo;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  const formattedPhone = t12;
  let t13;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = cn("grid grid-cols-[660px_480px] justify-between gap-x-60", "mobile-tablet:grid-cols-1 mobile-tablet:gap-x-0");
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== productName || $[37] !== safeThumbnail) {
    t14 = <div className="relative aspect-square w-full overflow-hidden rounded-large mobile-tablet:rounded-none"><Image fill={true} sizes="(max-width: 1279px) 100vw, 660px" src={safeThumbnail} alt={productName} className="object-cover" /></div>;
    $[36] = productName;
    $[37] = safeThumbnail;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== brandName) {
    t15 = brandName ? <div className="flex h-22 w-fit items-center justify-center rounded-pill bg-Gray-200 px-6 py-3"><span className="font-600 text-Gray-600 typo-caption2">{brandName}</span></div> : null;
    $[39] = brandName;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== productName) {
    t16 = <h1 className="font-700 text-Gray-900 typo-h7">{productName}</h1>;
    $[41] = productName;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t15 || $[44] !== t16) {
    t17 = <div className="flex flex-1 flex-col gap-8">{t15}{t16}</div>;
    $[43] = t15;
    $[44] = t16;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <button type="button" aria-label={"\uC0C1\uD488 \uACF5\uC720"} onClick={handleShare} className="size-20 shrink-0 text-Gray-900"><SvgShare2 className="size-full" /></button>;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== t17) {
    t19 = <div className="flex items-start justify-between gap-12">{t17}{t18}</div>;
    $[47] = t17;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== originalPrice) {
    t20 = originalPrice.toLocaleString();
    $[49] = originalPrice;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== t20) {
    t21 = <p className="font-700 text-Gray-700 typo-h5">{t20}P</p>;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t19 || $[54] !== t21) {
    t22 = <section className="hidden flex-col gap-16 px-20 mobile-tablet:flex">{t19}{t21}</section>;
    $[53] = t19;
    $[54] = t21;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Divider />;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="flex gap-16"><dt className="flex w-92 items-center gap-4 font-400 text-Gray-600 typo-body4">배송비<SvgInfo className="size-12 text-Gray-500" /></dt><dd className="font-700 text-Gray-900 typo-body4">무료배송</dd></div>;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  let t26;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <section className="hidden px-20 mobile-tablet:block"><dl className="flex flex-col gap-12">{t24}<div className="flex gap-16"><dt className="w-92 font-400 text-Gray-600 typo-body4">배송안내</dt><dd className="font-700 text-Gray-900 typo-body4">구매 후 바로 온라인 발급</dd></div></dl></section>;
    t26 = <Divider />;
    $[58] = t25;
    $[59] = t26;
  } else {
    t25 = $[58];
    t26 = $[59];
  }
  let t27;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <dt className="font-600 text-Gray-900 typo-body1 mobile-tablet:typo-body3">상품명</dt>;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== productName) {
    t28 = <div className="flex flex-col gap-8">{t27}<dd className="font-400 leading-normal text-Gray-600 typo-body3 mobile-tablet:typo-body4">{productName}</dd></div>;
    $[61] = productName;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== productType) {
    t29 = productType ? <div className="flex flex-col gap-8"><dt className="font-600 text-Gray-900 typo-body1 mobile-tablet:typo-body3">상품유형</dt><dd className="font-400 leading-normal text-Gray-600 typo-body3 mobile-tablet:typo-body4">{productType}</dd></div> : null;
    $[63] = productType;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] !== brandNotice) {
    t30 = brandNotice ? <div className="flex flex-col gap-8"><dt className="font-600 text-Gray-900 typo-body1 mobile-tablet:typo-body3">상품 정보</dt><dd className="whitespace-pre-wrap font-400 leading-normal text-Gray-600 typo-body3 mobile-tablet:typo-body4">{brandNotice}</dd></div> : null;
    $[65] = brandNotice;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  let t31;
  if ($[67] !== t28 || $[68] !== t29 || $[69] !== t30) {
    t31 = <dl className="flex flex-col gap-28 mobile-tablet:gap-24 mobile-tablet:px-20">{t28}{t29}{t30}</dl>;
    $[67] = t28;
    $[68] = t29;
    $[69] = t30;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <Divider />;
    $[71] = t32;
  } else {
    t32 = $[71];
  }
  let t33;
  if ($[72] !== availablePoints || $[73] !== isPointsInsufficient || $[74] !== isPreviewLoading || $[75] !== usedPoints) {
    t33 = <div className="mobile-tablet:hidden"><PointUsageSection availablePoints={availablePoints} usedPoints={usedPoints} isInsufficient={isPointsInsufficient} isLoading={isPreviewLoading} /></div>;
    $[72] = availablePoints;
    $[73] = isPointsInsufficient;
    $[74] = isPreviewLoading;
    $[75] = usedPoints;
    $[76] = t33;
  } else {
    t33 = $[76];
  }
  let t34;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Divider className="mobile-tablet:hidden" />;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <h2 className="font-700 text-Gray-900 typo-h6 mobile-tablet:typo-body2">결제 금액</h2>;
    $[78] = t35;
  } else {
    t35 = $[78];
  }
  let t36;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <dt className="font-700 text-Gray-900">보유 웰포인트</dt>;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] !== availablePoints || $[81] !== isPreviewLoading) {
    t37 = isPreviewLoading ? "-" : availablePoints.toLocaleString();
    $[80] = availablePoints;
    $[81] = isPreviewLoading;
    $[82] = t37;
  } else {
    t37 = $[82];
  }
  let t38;
  if ($[83] !== t37) {
    t38 = <div className="flex items-center justify-between">{t36}<dd className="font-700 text-Gray-900">{t37}P</dd></div>;
    $[83] = t37;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  let t39;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <dt className="font-500 text-Gray-600">상품 금액</dt>;
    $[85] = t39;
  } else {
    t39 = $[85];
  }
  const t40 = !isPreviewLoading && usedPoints > 0 && "-";
  let t41;
  if ($[86] !== isPreviewLoading || $[87] !== usedPoints) {
    t41 = isPreviewLoading ? "-" : usedPoints.toLocaleString();
    $[86] = isPreviewLoading;
    $[87] = usedPoints;
    $[88] = t41;
  } else {
    t41 = $[88];
  }
  let t42;
  if ($[89] !== t40 || $[90] !== t41) {
    t42 = <div className="flex items-center justify-between pl-4">{t39}<dd className="font-500 text-Gray-600">{t40}{t41}P</dd></div>;
    $[89] = t40;
    $[90] = t41;
    $[91] = t42;
  } else {
    t42 = $[91];
  }
  let t43;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Divider />;
    $[92] = t43;
  } else {
    t43 = $[92];
  }
  let t44;
  if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <dt>잔여 웰포인트</dt>;
    $[93] = t44;
  } else {
    t44 = $[93];
  }
  const t45 = leftPoints < 0 ? "text-R-400" : "text-Gray-900";
  let t46;
  if ($[94] !== t45) {
    t46 = cn(t45);
    $[94] = t45;
    $[95] = t46;
  } else {
    t46 = $[95];
  }
  let t47;
  if ($[96] !== isPreviewLoading || $[97] !== leftPoints) {
    t47 = isPreviewLoading ? "-" : leftPoints.toLocaleString();
    $[96] = isPreviewLoading;
    $[97] = leftPoints;
    $[98] = t47;
  } else {
    t47 = $[98];
  }
  let t48;
  if ($[99] !== t46 || $[100] !== t47) {
    t48 = <div className="flex items-center justify-between font-700 text-Gray-900 typo-h6">{t44}<dd className={t46}>{t47}P</dd></div>;
    $[99] = t46;
    $[100] = t47;
    $[101] = t48;
  } else {
    t48 = $[101];
  }
  let t49;
  if ($[102] !== t38 || $[103] !== t42 || $[104] !== t48) {
    t49 = <section className="flex flex-col gap-16 mobile-tablet:px-20">{t35}<dl className="flex flex-col gap-12 typo-body3">{t38}{t42}{t43}{t48}</dl></section>;
    $[102] = t38;
    $[103] = t42;
    $[104] = t48;
    $[105] = t49;
  } else {
    t49 = $[105];
  }
  const t50 = formattedPhone ? `[${formattedPhone}]` : "[\uD734\uB300\uC804\uD654\uBC88\uD638 \uBCC0\uC218]";
  let t51;
  if ($[106] !== t50) {
    t51 = <span className="font-700 text-O-400">{t50}</span>;
    $[106] = t50;
    $[107] = t51;
  } else {
    t51 = $[107];
  }
  let t52;
  if ($[108] !== verificationHref) {
    t52 = <CustomLink className="underline" href={verificationHref}>여기</CustomLink>;
    $[108] = verificationHref;
    $[109] = t52;
  } else {
    t52 = $[109];
  }
  let t53;
  if ($[110] !== t51 || $[111] !== t52) {
    t53 = <div className="bg-Gray-50 p-20 font-600 leading-normal text-Gray-600 typo-body4 mobile-tablet:mx-20">{t51}로 MMS 메시지를 통해 모바일 쿠폰을 발송합니다. 휴대전화 번호가 변경 되었거나 일치하지 않는 경우{" "}{t52}를 눌러 본인 인증을 다시 진행해 주세요. 인증이 완료되면 해당 번호로 프로필 정보가 자동 업데이트 됩니다.</div>;
    $[110] = t51;
    $[111] = t52;
    $[112] = t53;
  } else {
    t53 = $[112];
  }
  let t54;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = <p className="text-Gray-800 typo-body4">웰포인트상점 모바일쿠폰 발급 이용 약관</p>;
    $[113] = t54;
  } else {
    t54 = $[113];
  }
  let t55;
  let t56;
  if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = checked => {
      setIsCheckedExp(checked);
      setIsCheckedPhone(checked);
      setIsCheckedMms(checked);
      setIsCheckedPrivacy(checked);
    };
    t56 = <strong className="font-600 text-Gray-black typo-body4">약관 전체 동의</strong>;
    $[114] = t55;
    $[115] = t56;
  } else {
    t55 = $[114];
    t56 = $[115];
  }
  let t57;
  if ($[116] !== isAllChecked) {
    t57 = <div className="rounded-xsmall bg-Gray-100 px-14 py-12"><Checkbox className="gap-6 text-Gray-600 typo-caption1" checked={isAllChecked} onCheckedChange={t55}>{t56}</Checkbox></div>;
    $[116] = isAllChecked;
    $[117] = t57;
  } else {
    t57 = $[117];
  }
  let t58;
  if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = checked_0 => setIsCheckedExp(checked_0);
    $[118] = t58;
  } else {
    t58 = $[118];
  }
  let t59;
  if ($[119] !== isCheckedExp) {
    t59 = <Checkbox className="text-Gray-900 typo-caption1" checked={isCheckedExp} onCheckedChange={t58}>만료 기한 연장이 불가능한 모바일 쿠폰임을 확인했습니다.</Checkbox>;
    $[119] = isCheckedExp;
    $[120] = t59;
  } else {
    t59 = $[120];
  }
  let t60;
  if ($[121] === Symbol.for("react.memo_cache_sentinel")) {
    t60 = checked_1 => setIsCheckedPhone(checked_1);
    $[121] = t60;
  } else {
    t60 = $[121];
  }
  let t61;
  if ($[122] !== isCheckedPhone) {
    t61 = <Checkbox className="text-Gray-900 typo-caption1" checked={isCheckedPhone} onCheckedChange={t60}>전화번호 변경 및 기타 어떤 사유로도 재발급이 불가능합니다.</Checkbox>;
    $[122] = isCheckedPhone;
    $[123] = t61;
  } else {
    t61 = $[123];
  }
  let t62;
  if ($[124] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = checked_2 => setIsCheckedMms(checked_2);
    $[124] = t62;
  } else {
    t62 = $[124];
  }
  let t63;
  if ($[125] !== isCheckedMms) {
    t63 = <Checkbox className="text-Gray-900 typo-caption1" checked={isCheckedMms} onCheckedChange={t62}>MMS 메시지 수신이 가능한 상태임을 확인했습니다.</Checkbox>;
    $[125] = isCheckedMms;
    $[126] = t63;
  } else {
    t63 = $[126];
  }
  let t64;
  if ($[127] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = checked_3 => setIsCheckedPrivacy(checked_3);
    $[127] = t64;
  } else {
    t64 = $[127];
  }
  let t65;
  if ($[128] !== setTermsDrawerType) {
    t65 = <div>회원 본인은 위 주문 내용을 확인하였으며 서비스 약관, 개인정보 수집동의, 개인정보 제 3자 제공동의(웰로)에 동의합니다.{" "}<button type="button" className="font-700 text-Gray-black underline typo-caption1" onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        setTermsDrawerType(TERM_CATEGORY.DAOU_PROVIDE_PRIVACY_SELECT);
      }}>보기</button></div>;
    $[128] = setTermsDrawerType;
    $[129] = t65;
  } else {
    t65 = $[129];
  }
  let t66;
  if ($[130] !== isCheckedPrivacy || $[131] !== t65) {
    t66 = <Checkbox className="text-Gray-900 typo-caption1" checked={isCheckedPrivacy} onCheckedChange={t64}>{t65}</Checkbox>;
    $[130] = isCheckedPrivacy;
    $[131] = t65;
    $[132] = t66;
  } else {
    t66 = $[132];
  }
  let t67;
  if ($[133] !== t59 || $[134] !== t61 || $[135] !== t63 || $[136] !== t66) {
    t67 = <div className="mt-4 flex flex-col gap-6">{t59}{t61}{t63}{t66}</div>;
    $[133] = t59;
    $[134] = t61;
    $[135] = t63;
    $[136] = t66;
    $[137] = t67;
  } else {
    t67 = $[137];
  }
  let t68;
  if ($[138] !== t57 || $[139] !== t67) {
    t68 = <section ref={agreementSectionRef} className="flex flex-col gap-12 pb-40 mobile-tablet:px-20">{t54}{t57}{t67}</section>;
    $[138] = t57;
    $[139] = t67;
    $[140] = t68;
  } else {
    t68 = $[140];
  }
  let t69;
  if ($[141] !== t14 || $[142] !== t22 || $[143] !== t31 || $[144] !== t33 || $[145] !== t49 || $[146] !== t53 || $[147] !== t68) {
    t69 = <section className="flex flex-col gap-48 mobile-tablet:gap-24 mobile-tablet:pb-180">{t14}{t22}{t23}{t25}{t26}{t31}{t32}{t33}{t34}{t49}{t53}{t68}</section>;
    $[141] = t14;
    $[142] = t22;
    $[143] = t31;
    $[144] = t33;
    $[145] = t49;
    $[146] = t53;
    $[147] = t68;
    $[148] = t69;
  } else {
    t69 = $[148];
  }
  let t70;
  if ($[149] !== brandName) {
    t70 = brandName ? <div className="self-start bg-Gray-200 px-12 py-4"><span className="font-600 tracking-[-0.28px] text-Gray-600 typo-body4">{brandName}</span></div> : null;
    $[149] = brandName;
    $[150] = t70;
  } else {
    t70 = $[150];
  }
  let t71;
  if ($[151] !== productName) {
    t71 = <h1 className="font-800 leading-[1.2] text-Gray-900 typo-h4">{productName}</h1>;
    $[151] = productName;
    $[152] = t71;
  } else {
    t71 = $[152];
  }
  let t72;
  if ($[153] !== t70 || $[154] !== t71) {
    t72 = <div className="flex flex-1 flex-col gap-8">{t70}{t71}</div>;
    $[153] = t70;
    $[154] = t71;
    $[155] = t72;
  } else {
    t72 = $[155];
  }
  let t73;
  if ($[156] === Symbol.for("react.memo_cache_sentinel")) {
    t73 = <button type="button" aria-label={"\uC0C1\uD488 \uACF5\uC720"} onClick={handleShare} className="size-20 shrink-0 text-Gray-900"><SvgShare2 className="size-full" /></button>;
    $[156] = t73;
  } else {
    t73 = $[156];
  }
  let t74;
  if ($[157] !== t72) {
    t74 = <div className="flex items-start justify-between gap-12">{t72}{t73}</div>;
    $[157] = t72;
    $[158] = t74;
  } else {
    t74 = $[158];
  }
  let t75;
  if ($[159] !== originalPrice) {
    t75 = originalPrice.toLocaleString();
    $[159] = originalPrice;
    $[160] = t75;
  } else {
    t75 = $[160];
  }
  let t76;
  if ($[161] !== t75) {
    t76 = <p className="font-700 leading-[1.2] text-Gray-700 typo-h3">{t75}P</p>;
    $[161] = t75;
    $[162] = t76;
  } else {
    t76 = $[162];
  }
  let t77;
  if ($[163] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = <div className="flex gap-56"><dt className="flex w-92 items-center gap-4 font-500 leading-normal text-Gray-600 typo-body3">배송비<SvgInfo className="size-16 text-Gray-500" /></dt><dd className="font-700 leading-normal text-Gray-900 typo-body3">무료배송</dd></div>;
    $[163] = t77;
  } else {
    t77 = $[163];
  }
  let t78;
  if ($[164] === Symbol.for("react.memo_cache_sentinel")) {
    t78 = <dt className="w-92 font-500 leading-normal text-Gray-600 typo-body3">배송안내</dt>;
    $[164] = t78;
  } else {
    t78 = $[164];
  }
  let t79;
  if ($[165] === Symbol.for("react.memo_cache_sentinel")) {
    t79 = <dl className="flex flex-col gap-16">{t77}<div className="flex gap-56">{t78}<dd className="flex flex-col leading-normal"><span className="font-700 text-Gray-900 typo-body3">구매 후 바로 온라인 발급</span><span className="font-500 text-Gray-700 typo-body3">(식품의 경우 지연 발생 시 1주~2주 소요)</span></dd></div></dl>;
    $[165] = t79;
  } else {
    t79 = $[165];
  }
  let t80;
  if ($[166] !== t74 || $[167] !== t76) {
    t80 = <div className="flex flex-col gap-28">{t74}{t76}{t79}</div>;
    $[166] = t74;
    $[167] = t76;
    $[168] = t80;
  } else {
    t80 = $[168];
  }
  let t81;
  if ($[169] === Symbol.for("react.memo_cache_sentinel")) {
    t81 = <span className="flex-1 font-700 leading-[1.2] text-Gray-900 typo-h5">상품 금액</span>;
    $[169] = t81;
  } else {
    t81 = $[169];
  }
  let t82;
  if ($[170] !== originalPrice) {
    t82 = originalPrice.toLocaleString();
    $[170] = originalPrice;
    $[171] = t82;
  } else {
    t82 = $[171];
  }
  let t83;
  if ($[172] !== t82) {
    t83 = <div className="flex items-center justify-between gap-16">{t81}<span className="font-800 leading-[1.2] text-Gray-900 typo-h4">{t82}P</span></div>;
    $[172] = t82;
    $[173] = t83;
  } else {
    t83 = $[173];
  }
  let t84;
  if ($[174] === Symbol.for("react.memo_cache_sentinel")) {
    t84 = cn("flex h-68 w-full items-center justify-center bg-O-400 px-24 py-8 font-700 text-Gray-white transition-colors typo-h6", "disabled:bg-Gray-300 disabled:text-Gray-500");
    $[174] = t84;
  } else {
    t84 = $[174];
  }
  let t85;
  if ($[175] !== ctaDisabled || $[176] !== ctaLabel || $[177] !== handlePaymentClick) {
    t85 = <button type="button" disabled={ctaDisabled} onClick={handlePaymentClick} className={t84}>{ctaLabel}</button>;
    $[175] = ctaDisabled;
    $[176] = ctaLabel;
    $[177] = handlePaymentClick;
    $[178] = t85;
  } else {
    t85 = $[178];
  }
  let t86;
  if ($[179] !== t83 || $[180] !== t85) {
    t86 = <div className="flex flex-col gap-20">{t83}{t85}</div>;
    $[179] = t83;
    $[180] = t85;
    $[181] = t86;
  } else {
    t86 = $[181];
  }
  let t87;
  if ($[182] !== t80 || $[183] !== t86) {
    t87 = <aside className="py-32"><div className="flex flex-col gap-40">{t80}{t86}</div></aside>;
    $[182] = t80;
    $[183] = t86;
    $[184] = t87;
  } else {
    t87 = $[184];
  }
  let t88;
  if ($[185] === Symbol.for("react.memo_cache_sentinel")) {
    t88 = <GlobalDesktopSideAdBanner />;
    $[185] = t88;
  } else {
    t88 = $[185];
  }
  let t89;
  if ($[186] !== t87) {
    t89 = <div className="flex flex-col gap-40 mobile-tablet:hidden">{t87}{t88}</div>;
    $[186] = t87;
    $[187] = t89;
  } else {
    t89 = $[187];
  }
  let t90;
  if ($[188] !== t69 || $[189] !== t89) {
    t90 = <div className={t13}>{t69}{t89}</div>;
    $[188] = t69;
    $[189] = t89;
    $[190] = t90;
  } else {
    t90 = $[190];
  }
  let t91;
  if ($[191] === Symbol.for("react.memo_cache_sentinel")) {
    t91 = <p className="font-700 typo-caption1"><span className="text-Gray-white">이 상품은</span><span className="text-O-400"> 웰포인트로만 </span><span className="text-Gray-white">구매가 가능해요!</span></p>;
    $[191] = t91;
  } else {
    t91 = $[191];
  }
  let t92;
  if ($[192] === Symbol.for("react.memo_cache_sentinel")) {
    t92 = <span className="font-700 text-Gray-900 typo-body3">상품 금액</span>;
    $[192] = t92;
  } else {
    t92 = $[192];
  }
  let t93;
  if ($[193] !== originalPrice) {
    t93 = originalPrice.toLocaleString();
    $[193] = originalPrice;
    $[194] = t93;
  } else {
    t93 = $[194];
  }
  let t94;
  if ($[195] !== t93) {
    t94 = <div className="flex items-center justify-between py-8">{t92}<span className="font-700 text-Gray-black typo-body1">{t93}P</span></div>;
    $[195] = t93;
    $[196] = t94;
  } else {
    t94 = $[196];
  }
  let t95;
  if ($[197] === Symbol.for("react.memo_cache_sentinel")) {
    t95 = cn("flex h-56 w-full items-center justify-center bg-O-400 font-700 text-Gray-white typo-body3", "disabled:bg-Gray-300 disabled:text-Gray-500");
    $[197] = t95;
  } else {
    t95 = $[197];
  }
  let t96;
  if ($[198] !== ctaDisabled || $[199] !== ctaLabel || $[200] !== handlePaymentClick) {
    t96 = <button type="button" disabled={ctaDisabled} onClick={handlePaymentClick} className={t95}>{ctaLabel}</button>;
    $[198] = ctaDisabled;
    $[199] = ctaLabel;
    $[200] = handlePaymentClick;
    $[201] = t96;
  } else {
    t96 = $[201];
  }
  let t97;
  if ($[202] !== t94 || $[203] !== t96) {
    t97 = <BottomSheet toast={t91}><div className="flex flex-col gap-12">{t94}{t96}</div></BottomSheet>;
    $[202] = t94;
    $[203] = t96;
    $[204] = t97;
  } else {
    t97 = $[204];
  }
  let t98;
  if ($[205] === Symbol.for("react.memo_cache_sentinel")) {
    t98 = () => setIsVerifyModalOpen(false);
    $[205] = t98;
  } else {
    t98 = $[205];
  }
  let t100;
  let t99;
  if ($[206] === Symbol.for("react.memo_cache_sentinel")) {
    t99 = <span className="w-full text-center mobile:typo-body1">모바일 쿠폰 발송을 위해<br />본인인증이 필요합니다</span>;
    t100 = <span className="inline-block w-full text-center">계속 하시겠습니까?</span>;
    $[206] = t100;
    $[207] = t99;
  } else {
    t100 = $[206];
    t99 = $[207];
  }
  let t101;
  if ($[208] !== router || $[209] !== verificationHref) {
    t101 = <Button dimensions="H48" className="flex-1" onClick={() => {
      setIsVerifyModalOpen(false);
      router.push(verificationHref);
    }}>확인</Button>;
    $[208] = router;
    $[209] = verificationHref;
    $[210] = t101;
  } else {
    t101 = $[210];
  }
  let t102;
  if ($[211] === Symbol.for("react.memo_cache_sentinel")) {
    t102 = <Button theme="sub-line" dimensions="H48" className="flex-1" onClick={() => setIsVerifyModalOpen(false)}>취소</Button>;
    $[211] = t102;
  } else {
    t102 = $[211];
  }
  let t103;
  if ($[212] !== t101) {
    t103 = <div className="flex items-center gap-12">{t101}{t102}</div>;
    $[212] = t101;
    $[213] = t103;
  } else {
    t103 = $[213];
  }
  let t104;
  if ($[214] !== isVerifyModalOpen || $[215] !== t103) {
    t104 = <Modal opened={isVerifyModalOpen} onClose={t98} header={t99} description={t100} buttonFooter={t103} />;
    $[214] = isVerifyModalOpen;
    $[215] = t103;
    $[216] = t104;
  } else {
    t104 = $[216];
  }
  let t105;
  if ($[217] !== t104 || $[218] !== t90 || $[219] !== t97) {
    t105 = <article className="mx-auto w-full max-w-root pt-100 mobile-tablet:pt-0">{t90}{t97}{t104}</article>;
    $[217] = t104;
    $[218] = t90;
    $[219] = t97;
    $[220] = t105;
  } else {
    t105 = $[220];
  }
  return t105;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(state_0) {
  return state_0.myInfo;
}
function _temp3(state_1) {
  return state_1.setTermsDrawerType;
}
function _temp4(t0) {
  const {
    context
  } = t0;
  return context;
}
function _temp5() {
  if (typeof window === "undefined") {
    return;
  }
  openShareDrawer(window.location.href);
}